// extracted by mini-css-extract-plugin
export default {"logo":"navbar_logo__QpvlK","logoutbutton":"navbar_logoutbutton__z9rWQ"};